import { render, staticRenderFns } from "./global-state-aggregator-oro.vue?vue&type=template&id=3bf2bcac&scoped=true&"
import script from "./global-state-aggregator-oro.vue?vue&type=script&lang=js&"
export * from "./global-state-aggregator-oro.vue?vue&type=script&lang=js&"
import style0 from "./global-state-aggregator-oro.vue?vue&type=style&index=0&id=3bf2bcac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2bcac",
  null
  
)

export default component.exports